import { Stack, SxProps, Theme, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import OldPackageCard from "@/components/online-store/packages/oldPackageCard/oldPackageCard";
import PackageCard from "@/components/online-store/packages/packageCard/packageCard";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import { MedspaPackage } from "@/views/online-store/onlineStoreView";
import OnlineStoreEmptySection from "../onlineStoreEmptySection";

type Props = {
  packages: MedspaPackage[];
  customizationEnabled: boolean;
  customizationPrimaryColor: string;
  medspaId: string;
  labelSx?: SxProps<Theme>;
  setIsCheckoutDrawerOpen: (isOpen: boolean) => void;
  packageCardRevampV1Enabled: boolean;
};

export default function AllPackagesSection({
  packages,
  customizationEnabled,
  customizationPrimaryColor,
  medspaId,
  labelSx,
  setIsCheckoutDrawerOpen,
  packageCardRevampV1Enabled,
}: Props) {
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  if (packages.length === 0)
    return (
      <>
        {!isMobile && <SectionHeader labelSx={labelSx} />}
        <OnlineStoreEmptySection />
      </>
    );

  return (
    <>
      <SectionHeader labelSx={labelSx} />
      <Grid
        container
        spacing={2}
        sx={{
          mt: 1,
          mb: 10,
          gap: 2,
        }}
      >
        {packages.map((packageItem) => (
          <Grid
            size={{
              xs: packageCardRevampV1Enabled ? 6 : 12,
              sm: 6,
              md: 4,
              lg: 3,
            }}
            key={packageItem.id}
          >
            {packageCardRevampV1Enabled ? (
              <PackageCard
                packageItem={packageItem}
                customizationEnabled={customizationEnabled}
                customizationPrimaryColor={customizationPrimaryColor}
                medspaId={medspaId}
                setIsCheckoutDrawerOpen={setIsCheckoutDrawerOpen}
              />
            ) : (
              <OldPackageCard
                packageItem={packageItem}
                customizationEnabled={customizationEnabled}
                customizationPrimaryColor={customizationPrimaryColor}
                medspaId={medspaId}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
}

const SectionHeader = ({ labelSx }: { labelSx: SxProps<Theme> }) => {
  return (
    <Stack spacing={1} sx={{ ...labelSx }}>
      <Typography variant="h1">All packages & gift cards</Typography>
      <Typography
        sx={{
          color: "text.secondary",
        }}
      >
        Take advantage of our full range of packages and gift cards.
      </Typography>
    </Stack>
  );
};
